module.exports = __webpack_public_path__ + "img/userpic.f1a8f7dc.png";